import { render, staticRenderFns } from "./leftColCompartirD.vue?vue&type=template&id=16677604"
import script from "./leftColCompartirD.vue?vue&type=script&lang=js"
export * from "./leftColCompartirD.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports